/**
 * Post Note
 * @type {string}
 */
export const SHOW_MAIN_NAV = 'SHOW_MAIN_NAV';
export const SET_INDEX = 'SET_INDEX';
export const SET_VISIBILITY = 'SET_VISIBILITY';


